import { ApiContext } from "../../contexts/ApiContext";
import { useContext } from "react";
import { useQuery } from "react-query";

export function useAlternativeRegionNames(customerId?: number) {
  const apiContext = useContext(ApiContext);
  return useQuery({
    queryKey: ["alternativeRegionNames", customerId],
    queryFn: async () => {
      if (customerId) return await apiContext.customerApis.getAlternativeRegionNames(customerId);
    },
  });
}
